import { useAuth } from '../../../src/context/AuthContext';
import ReviewerMySubmissionsScreen from '../../../src/screens/ReviewerMySubmissionsScreen';
import OwnerPendingReviewScreen from '../../../src/screens/OwnerPendingReviewScreen';
import AdminReportsScreen from '../../../src/screens/AdminReportsScreen';

export default function TasksTab() {
  const { user, activeMode } = useAuth();
  if (user?.role === 'ADMIN') return <AdminReportsScreen />;
  return activeMode === 'SHOP_OWNER' ? <OwnerPendingReviewScreen /> : <ReviewerMySubmissionsScreen />;
}
